import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import { FieldArray } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../Config';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { getKycDocList } from '../../../../Redux/action/MasterAction';
import { useDispatch } from 'react-redux';
const AddMaster = ({ show, handleClose, onSuccess }) => {

    const dispatch = useDispatch();
    const DocTypeOptions = [
        { value: '.doc', label: '.doc' },
        { value: '.docx', label: '.docx' },
        { value: '.rtf', label: '.rtf' },
        { value: '.pdf', label: '.pdf' },
        { value: '.wpd', label: '.wpd' },
        { value: '.jpg', label: '.jpg' },
        { value: '.jpeg', label: '.jpeg' },
        { value: '.png', label: '.png' },
        { value: '.heif', label: '.heif' },
        { value: '.xlsx', label: '.xlsx' },
        { value: '.xls', label: '.xls' },
        { value: '.csv', label: '.csv' },
    ];

    const validationSchema = Yup.object({
        customer_type: Yup.string().required('Customer Type is required'),
        name: Yup.array()
            .of(
                Yup.string()
                    .transform((value) => value.trim())
                    .required('Document name is required')
                    .min(1, 'Document name cannot be empty or just spaces')
            ),
        doucumentFormat: Yup.array()
            .min(1, 'At least one Document Format is required')
            .required('Document Format is required'),
    });




    const formik = useFormik({
        initialValues: {
            customer_type: '',
            name: [''],
            doucumentFormat: [],
            mandatory: false,
        },
        validationSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const response = await fetch(
                    `${adminMainUrl}/api/kyc-doc/create`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
                            'user_id': Cookies.get('flexichain_user_id')
                        },
                        body: JSON.stringify(values),
                    }
                );

                const data = await response.json();

                if (response.ok) {
                    setSubmitting(false)


                    toast.success(data?.msg);
                    resetForm();
                    handleClose();
                    if (onSuccess) onSuccess();
                } else {
                    setSubmitting(false)

                    toast.error(data?.msg);
                }
            } catch (error) {
                setSubmitting(false)

                console.error("Network error:", error);
            }

        },
    });

    // Handle switch change
    const handleSwitchChange = (e) => {
        formik.setFieldValue('mandatory', e.target.checked);
    };
    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Add Kyc Document</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    {/* Customer Type */}
                    <div className="mb-3">
                        <label htmlFor="customer_type" className="form-label">
                            Customer Type <span style={{ color: 'red' }}>*</span>
                        </label>
                        <select
                            className="form-select form-control-sm"
                            id="customer_type"
                            name="customer_type"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.customer_type}
                        >
                            <option value="">Select Customer Type</option>
                            <option >
                                Individual/Proprietary firm
                            </option>
                            <option>
                                Private or Public Limited Company
                            </option>
                            <option>
                                Partnership firm
                            </option>
                        </select>
                        {formik.touched.customer_type && formik.errors.customer_type ? (
                            <div className="error">{formik.errors.customer_type}</div>
                        ) : null}
                    </div>

                    {/* Document Name */}
                    <div className="mb-3">
                        <label className="form-label">
                            Document Name(s) <span style={{ color: 'red' }}>*</span>
                        </label>

                        {formik.values.name.map((doc, index) => (
                            <div key={index} className="d-flex gap-2 mb-2">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name={`name[${index}]`}
                                    value={formik.values.name[index]}
                                    onChange={(e) => {
                                        const newNames = [...formik.values.name];
                                        newNames[index] = e.target.value;
                                        formik.setFieldValue('name', newNames);
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                                {index > 0 && (
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => {
                                            const newNames = formik.values.name.filter((_, i) => i !== index);
                                            formik.setFieldValue('name', newNames);
                                        }}
                                    >
                                        Remove
                                    </button>
                                )}
                            </div>
                        ))}

                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => formik.setFieldValue('name', [...formik.values.name, ''])}
                        >
                            + Add Document Name
                        </button>

                        {/* {formik.errors.name && (
                            <div className="error">{formik.errors.name}</div>
                        )} */}
                        {Array.isArray(formik.errors.name) && formik.errors.name.find(Boolean) && (
                            <div className="error">{formik.errors.name.find(Boolean)}</div>
                        )}
                    </div>


                    {/* Document Type (React-Select component) */}
                    <div className="mb-3">
                        <label htmlFor="doucumentFormat" className="form-label">
                            Document Format <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Select
                            closeMenuOnSelect={false}
                            components={makeAnimated()}
                            isMulti
                            options={DocTypeOptions}
                            onChange={(selectedOptions) =>
                                formik.setFieldValue(
                                    'doucumentFormat',
                                    selectedOptions ? selectedOptions.map(option => option.value) : []
                                )
                            }
                            value={DocTypeOptions.filter(option =>
                                formik.values.doucumentFormat?.includes(option.value)
                            )}
                        />
                        {formik.touched.doucumentFormat && formik.errors.doucumentFormat ? (
                            <div className="error">{formik.errors.doucumentFormat}</div>
                        ) : null}
                    </div>

                    {/* Mandatory Switch */}
                    <div className="mb-3">
                        <label className="form-label">
                            Is it mandatory?
                        </label>
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                onChange={handleSwitchChange}
                                checked={formik.values.mandatory}
                            />
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary text-xs" type="submit" disabled={formik.isSubmitting}>
                            {formik.isSubmitting ? <i className="fa fa-spinner fa-spin" /> : 'Submit'}
                        </button>
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default AddMaster